// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_app_alpha_status = /** @type {(inputs: {}) => string} */ () => {
	return `Alpha`
};

const id_app_alpha_status = /** @type {(inputs: {}) => string} */ () => {
	return `Alfa`
};

const ja_app_alpha_status = /** @type {(inputs: {}) => string} */ () => {
	return `アルファ`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const app_alpha_status = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.app_alpha_status(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("app_alpha_status", locale)
	if (locale === "en") return en_app_alpha_status(inputs)
	if (locale === "id") return id_app_alpha_status(inputs)
	return ja_app_alpha_status(inputs)
};
export { app_alpha_status as "app.alpha_status" }